import AdminPermissions from 'constants/adminPermissions';

export default {
  main: [
    {
      name: 'Dashboard',
      path: '/',
    },
    {
      name: 'My Profile',
      path: '/profile',
      permission: 'payroll_employee:edit',
    },
    {
      name: 'My Files',
      path: '/myfiles',
    },
    {
      name: 'My Pay Stubs',
      path: '/paystubs',
      permission: 'paystubs:read',
    },
    {
      name: 'My Tax Documents',
      path: '/taxdocuments',
      permission: 'tax_documents:read',
    },
  ],
  usa: [
    {
      name: 'Loan-out',
      path: '/loanout',
      featureFlag: 'MyCnC-LoanOuts',
    },
    {
      name: 'My W-4s',
      path: '/w4s',
      permission: 'payroll_employee:edit',
    },
    {
      name: 'Support',
      path: '/crew-support',
    },
  ],
  canada: [
    {
      name: 'My TD1s',
      path: '/td1s',
      permission: 'payroll_employee:edit',
    },
    {
      name: 'Support',
      path: '/crew-support',
    },
  ],
  mainAdmin: [
    {
      name: 'Admin Dashboard',
      path: '/admin',
      permission: AdminPermissions,
    },
  ],
  admin: [
    {
      name: 'Admin Dashboard',
      path: '/admin',
      permission: AdminPermissions,
    },
    {
      name: 'Tax Document Upload',
      path: '/admin/taxdocumentsupload',
      permission: ['tax_documents:create'],
    },
    {
      name: 'Tax Documents',
      path: '/admin/taxdocuments',
      permission: ['tax_documents_log:read', 'tax_documents:edit'],
    },
    {
      name: 'Registration Logs',
      path: '/admin/registrationlogs',
      permission: ['employee_registrations:read'],
    },
    {
      name: 'Registration',
      path: '/admin/registration',
      permission: ['employee_registrations:create'],
    },
    {
      name: 'Employee Lookup',
      path: '/admin/employeelookup',
      permission: ['employee_registrations:read', 'users:read'],
    },
    {
      name: 'CCPA',
      path: '/admin/ccpa',
      permission: ['ccpa:access'],
    },
    {
      name: 'ID Logs',
      path: '/admin/idlogs',
      permission: ['employee_registrations:read'],
    },
    {
      name: 'Plaid Status',
      path: '/admin/plaidstatus',
      permission: ['employee_registrations:read'],
    },
    {
      name: 'Health Checks',
      path: '/admin/health-checks',
      permission: ['status:read'],
    },
    {
      name: 'Notifications',
      path: '/admin/send-notifications',
      permission: ['notification:create'],
      featureFlag: 'MyCnC-NotificationBuilder',
    },
  ],
  offer: {
    US: [
      {
        name: 'My Profile',
        path: '/offer/profile',
        permission: 'payroll_employee:edit',
      },
      {
        name: 'My W-4s',
        path: '/offer/w4s',
        permission: 'payroll_employee:edit',
      },
      {
        name: 'Loan-out',
        path: '/offer/loanout',
        featureFlag: 'MyCnC-LoanOuts',
      },
      {
        name: 'Support',
        path: '/offer/support',
      },
    ],
    CAN: [
      {
        name: 'My Profile',
        path: '/offer/profile',
        permission: 'payroll_employee:edit',
      },
      {
        name: 'My TD1s',
        path: '/offer/td1s',
        permission: 'payroll_employee:edit',
      },
      {
        name: 'Loan-out',
        path: '/offer/loanout',
        featureFlag: 'MyCnC-LoanOuts',
      },
      {
        name: 'Support',
        path: '/offer/support',
      },
    ],
  },
  profile: [
    {
      name: 'Profile Information',
      path: '/profile',
    },
    {
      name: 'Addresses',
      path: '/profile/addresses',
    },
  ],
};
